import { render } from "./category-base-tab.vue?vue&type=template&id=4046ab64"
import script from "./category-base-tab.vue?vue&type=script&lang=js"
export * from "./category-base-tab.vue?vue&type=script&lang=js"

import "./category-base-tab.vue?vue&type=style&index=0&id=4046ab64&lang=scss"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__